import {
  CLEAR_DEVICE_AUTH_VALIDATION,
  DeviceAuthAction,
  SET_DEVICE_AUTH_CODE,
  SET_DEVICE_AUTH_CODE_STATUS,
  SET_DEVICE_AUTH_CODE_VALIDATION_ERROR,
  SET_DEVICE_AUTH_REDIRECT_URL,
  SET_IS_ACTIVATING_DEVICE,
  SET_IS_VALIDATING_DEVICE_AUTH_CODE,
  UPDATE_DEVICE_AUTH_STATE,
} from '../actions/device-auth';
import DEFAULT_STATE, { DeviceAuthState } from '../defaults/device-auth';
import createReducer from './create-reducer';

function updateDeviceAuth(state: DeviceAuthState, { type, ...payload }: DeviceAuthAction) {
  return {
    ...state,
    ...payload,
  };
}

const handlers = {
  [CLEAR_DEVICE_AUTH_VALIDATION]: updateDeviceAuth,
  [UPDATE_DEVICE_AUTH_STATE]: updateDeviceAuth,
  [SET_IS_ACTIVATING_DEVICE]: updateDeviceAuth,
  [SET_DEVICE_AUTH_CODE_STATUS]: updateDeviceAuth,
  [SET_DEVICE_AUTH_CODE_VALIDATION_ERROR]: updateDeviceAuth,
  [SET_DEVICE_AUTH_CODE]: updateDeviceAuth,
  [SET_IS_VALIDATING_DEVICE_AUTH_CODE]: updateDeviceAuth,
  [SET_DEVICE_AUTH_REDIRECT_URL]: updateDeviceAuth,
};

export default createReducer(DEFAULT_STATE, handlers);
